import { viewerStrings } from '../copy/strings.js';
import { useEffect, useState } from 'react';
import type { IHeaderParams } from 'ag-grid-community';
import { FreezeIcon } from './FreezeIcon.js';

/** Add only the requested pin action in the native header's supported inner-label slot. */
export function ColumnLabel({ api, column, displayName }: IHeaderParams) {
  const [pinned, setPinned] = useState(!!column.getPinned());
  useEffect(() => {
    const refresh = () => setPinned(!!column.getPinned());
    api.addEventListener('columnPinned', refresh);
    return () => {
      if (!api.isDestroyed()) api.removeEventListener('columnPinned', refresh);
    };
  }, [api, column]);
  return (
    <span className="column-label">
      <span>{displayName}</span>
      <FreezeIcon
        active={pinned}
        label={
          pinned
            ? viewerStrings.webComponentsColumnLabel.unfreezeColumn
            : viewerStrings.webComponentsColumnLabel.freezeColumn
        }
        onClick={() => api.setColumnsPinned([column], column.getPinned() ? null : 'left')}
        accessibleLabel={
          pinned
            ? viewerStrings.webIconAccessibility.webComponentsColumnLabelunfreezeColumn
            : viewerStrings.webIconAccessibility.webComponentsColumnLabelfreezeColumn
        }
      />
    </span>
  );
}
